<template>
  <checkout-layout>
    <div class="header">
      <checkout-headline :title="$t('checkout.existingNumber.title')" :text="$t('checkout.existingNumber.text')"/>
    </div>
    <div class="new-cable-wrapper">
      <div class="new-cable-wrapper-desc">
        <h2>{{ $t('checkout.newCable.enterJmbg') }}</h2>
        <span>{{ $t('checkout.newCable.enterJmbgDescription') }}</span>
      </div>
      <div class="new-cable-form">
        <validation-observer ref="uniqueIdForm"
                             tag="form"
                             @submit.prevent="submitForm">
          <base-v-input v-model="uniqueId"
                        :label="$t('checkout.freeNumber.jmbgLabel')"
                        :submitted="formSubmitted"
                        type="number"
                        name="uniqueId"
                        pattern="\d*"
                        rules="required|digits:13|jmbg"/>
          <base-button type="submit">{{ $t('common.continue') }}</base-button>
        </validation-observer>
      </div>
    </div>
  </checkout-layout>
</template>

<script>
import CheckoutLayout from '../checkout-layout'
import CheckoutHeadline from '@/components/checkout/checkout-headline'
import BaseButton from '@/components/base/base-button'
import BaseVInput from '@/components/base/base-v-input'
import cartComponentsProps from '../config/cartComponentsProps'
import { verifyCableNew } from '@/api/checkout'
import { checkoutViews } from '../config/checkoutViews'
import errorMessageHandler from '@/mixins/errorMessageHandler'
export default {
  name: 'user-identification-new-cable',
  mixins: [errorMessageHandler],
  props: { ...cartComponentsProps },
  components: { CheckoutLayout, CheckoutHeadline, BaseButton, BaseVInput },
  data () {
    return {
      uniqueId: '',
      formSubmitted: false
    }
  },

  methods: {
    async submitForm () {
      const params = {
        cartId: this.$props.cartData.guid,
        jmbg: this.uniqueId
      }
      const valid = await this.$refs.uniqueIdForm.validate()
      this.formSubmitted = true
      if (valid) {
        this.$loader.show()
        verifyCableNew(params).then(response => {
          if (response.status >= 200 && response.status < 400) {
            this.$emit('update-component', checkoutViews.checkoutPreview.name)
          }
        }).catch(err => {
          this.$loader.hide()
          this.handleErrorMessage(err.response.data)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  background-color: $light-grey;
  @media (map_get($breakpoints, sm)) {
    margin-top: 15rem;
    text-align: center;
  }

  h1 {
    color: $black;
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 15px;
    @media (map_get($breakpoints, sm)) {
      font-size: 3.2rem;
      line-height: 1.31;
      font-weight: normal;
      margin-bottom: 1rem;
    }
  }

  span {
    font-size: 1.4rem;
    color: $light-black;
    @media (map_get($breakpoints, sm)) {
      font-size: 1.6rem;
    }
  }
}

.new-cable-wrapper {
  padding: 2.4rem;
  background: $white;

  @media (map_get($breakpoints, sm)) {
    padding: 4.8rem 4rem;
  }

  @media (map_get($breakpoints, md)) {
    margin: 0 auto;
    padding: 4.8rem 8rem;
    max-width: 68rem;
  }

  .base-button {
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      margin-top: auto;
      width: auto;
    }
  }
}

.new-cable-wrapper-desc {
  margin-bottom: 2.4rem;
  h2 {
    margin-bottom: .8rem;
    font-size: 2rem;
    font-weight: 400;

    @media (map_get($breakpoints, md)) {
      margin-bottom: 1.6rem;
      font-weight: 500;
    }
  }

  span {
    font-size: 1.4rem;
  }
}

.new-cable-form {
  > form {
    @media (map_get($breakpoints, sm)) {
      display: flex;
      align-items: center;
    }

    .validated-input {
      @media (map_get($breakpoints, sm)) {
        margin-right: 2.4rem;
        padding-bottom: 0;
        width: 100%;
      }
    }
  }
}
</style>
